import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useLocation, useParams } from "react-router-dom";
import "../../../../client/assets/css/cms/Products.css";
import loadable from "@loadable/component";
import Loading from "../../../../client/components/utils/loader";
import { useDispatch, useSelector } from "react-redux";

const ManageJobsOverview = loadable(() => import("./manageJobs"), {
    fallback: () => <Loading />,
});
const ManageApplicantsOverview = loadable(() => import("./manageApplicants"), {
    fallback: () => <Loading />,
});
const ManageHiring = loadable(() => import("../hiring/manageJobs/manageHiring"), {
    fallback: () => <Loading />,
});
const ManageApplicants = loadable(() => import("../hiring/manageApplicants/manageApplicants"), {
    fallback: () => <Loading />,
});
const PermissionDenied = loadable(() => import("../../cms/common/permissionDenied"), {
    fallback: () => <Loading />,
});
function HiringOverview(props) {
    const router = useLocation();
    const { param } = useParams();

    const { userPermission } = useSelector((state) => {
        return state.userData; // Returning the desired state values
    });

    let relatedPath = router.pathname.split("/add-edit")[0];
    const [activeComponent, setActiveComponent] = useState();

    const HIRING_ROUTES = [
        {
            path: "",
            exact: true,
            value: "",
            element: <ManageJobsOverview />,
            application: "hiring_admin",
            action: "Can View Job Listing Page"
        },
        {
            path: "manage-jobs",
            exact: true,
            value: "",
            element: <ManageHiring />,

        },
        {
            path: "applicants",
            exact: true,
            value: "",
            element: <ManageApplicantsOverview />,
            application: "hiring_admin",
            secondary_application: "hiring_interviewer",
            action: "Can View Applicant Listing Page"
        },
        {
            path: "manage-applicants",
            exact: true,
            value: "",
            element: <ManageApplicants />
        },
    ];

    useEffect(() => {
        if (param) {
            let activeComponent = HIRING_ROUTES.find((obj) => {
                if (obj.path == param) {
                    return obj;
                }
            })
            if ((activeComponent?.application && activeComponent?.action && !viewManageApplicantsListing(activeComponent?.application, activeComponent?.action)) && (activeComponent?.secondary_application && activeComponent?.action && !viewManageApplicantsListing(activeComponent?.secondary_application, activeComponent?.action))) {
                setActiveComponent(<PermissionDenied />)
            }
            else if (activeComponent) {
                setActiveComponent(activeComponent?.element);
            } else {
                setActiveComponent(HIRING_ROUTES[0].element);
            }
        } else {
            if (!viewManageJobListing(HIRING_ROUTES[0]?.application, HIRING_ROUTES[0]?.action)) {
                setActiveComponent(<PermissionDenied />)
            }
            else {
                setActiveComponent(HIRING_ROUTES[0].element);
            }
        }
    }, [param]);

    const viewManageJobListing = (contentType, permissionName) => {
        let authorized = false;
        const userPermissions = userPermission?.data;
        if (userPermissions) {
            authorized = userPermissions.some(permission => {
                return permission.content_type === contentType && permission.name === permissionName
            });
        }
        return authorized;
    }

    const viewManageApplicantsListing = (contentType, permissionName) => {
        let authorized = false;
        const userPermissions = userPermission?.data;
        if (userPermissions) {
            authorized = userPermissions.some(permission => {
                return permission.content_type === contentType && permission.name === permissionName
            });
        }
        return authorized;
    }

    return (
        <div>
            <div className={"nav_container"}>
                <Nav className={"sub_nav"}>
                    <Nav.Item
                        className={`${relatedPath == "/cms/hiring" ||
                            router.pathname == "/cms/hiring/manage-jobs"
                            ? "nav_links_active"
                            : ""
                            }`}
                    >
                        <Nav.Link>
                            {" "}
                            <Link to="/cms/hiring">Manage Jobs</Link>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item
                        className={`${relatedPath == "/cms/hiring/applicants" ||
                            router.pathname == "/cms/hiring/manage-applicants"
                            ? "nav_links_active"
                            : ""
                            }`}
                    >
                        <Nav.Link>
                            {" "}
                            <Link to="/cms/hiring/applicants">Manage Applicants</Link>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            {/* <DyanamicRoutes {...props} /> */}
            {activeComponent}
        </div>
    );
}

export default HiringOverview;
